const crypto = require("crypto-js");
const { default: config } = require("../configs");

const encrypt = (str) => crypto.AES.encrypt(str, config.cryptoKey).toString();
const decrypt = (str) =>
  crypto.AES.decrypt(str, config.cryptoKey).toString(crypto.enc.Utf8);

module.exports = { encrypt, decrypt };
